import React from "react";
import "./index.scss";
import { Divider  } from 'antd';
const Footer = () => {
  return (
    <footer
      id="footer"
      className="footer"
      style={{
        background: `#2e2e2e url(${process.env.PUBLIC_URL}/images/footer-bg.jpg) no-repeat center 0`,
        backgroundSize: "cover",
      }}
    >
      <div className="container">
        <div className="inner-container">

        <div className="footer-info-section">
          <p className="footer-info-section-header">ABOUT US</p>
          <div className="about-us-text">
            CDC is a Collaboration of Computer, Data & Concepts with over 20
            years of experience in IT Staffing industry. We provide Computer
            Personnel, Data Services & Concepts in IT. We are all about
            achieving Optimization in Hiring Processes, Delivery of Candidates,
            Profit Maximization, Cost Effectiveness & Customer Satisfaction
            through our services.
          </div>
        </div>
        <div className="footer-info-section">
          <p className="footer-info-section-header">GALLERY</p>
          <div className="footer-img-gallery-container">
            {Array.from({ length: 6 }).map((_, index) => {
              const imgIndex = index + 1;
              return (
                <img
                  key={index}
                  className="footer-img-gallery"
                  src={`/images/gallery/${imgIndex}.${imgIndex === 6 ? "jpg" : "png"}`}
                  alt=""
                />
              );
            })}
          </div>
        </div>
        <div className="footer-info-section">
          <p className="footer-info-section-header">CONTACT US</p>
          <div className="contact-lines">
            <div className="contact-label">Email:</div>
            <div className="about-us-text">info@computerdataconcepts.com</div>
            <div className="contact-label">Phone No.</div>
            <div className="about-us-text">908-888-6099</div>
          </div>
        </div>
<Divider />
        </div>
      </div>
      <div>
   
      </div>
      <div className="copyright-section-container">© Copyright {new Date().getFullYear()} CDC.</div>
    </footer>
  );
};

export default Footer;
